/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { useShowError } from "~/components/Error/useShowError";
import { useAxios, useQueryState } from "~/tools";

const useProductCatalog = (sortBy: string, order: string) => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [productCatalog, setProductCatalog] = React.useState({
    list: [],
    totalCount: 0,
  });

  const { Axios } = useAxios();
  const [{ limit, page, query }] = useQueryState();
  const { showError } = useShowError();

  const fetchProductCatalog = React.useCallback(async () => {
    try {
      const params = { limit, page, query, sortBy, order };
      const { data } = await Axios().get("/catalog/products", params);
      setProductCatalog({
        list: data?.products,
        totalCount: data?.totalCount,
      });
    } catch (e) {
      showError(e.response);
    } finally {
      setIsLoading(false);
    }
  }, [Axios, limit, page, query, sortBy, order, showError]);

  React.useEffect(() => {
    fetchProductCatalog();
  }, [fetchProductCatalog]);

  return { productCatalog, isLoading };
};

export { useProductCatalog };
